module.exports = __webpack_public_path__ + "img/salmon_rice_paper_prep.cdf6cf7e.jpg";